import './EntitySelector.scss';
import entity from '../../model/entity';
import Entity from './Entity';
import React from 'react';

const createDefaultSearcher = ({
  contentType,
  params,
  showArchived,
  filterFn
}) => {
  return ({
    query,
    offset,
    limit
  }) => {
    return entity.search({
      query: query,
      offset: offset,
      limit: limit,
      contentType: contentType,
      options: params,
      showArchived: showArchived,
      filterFn: filterFn
    });
  };
};

class EntitySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      searching: false,
      result: null
    };

    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleLoadMore() {
    this.setState({
      searching: true
    });

    const query = this.state.query;
    const previous = this.state.result.items;
    const offset = this.state.result.offset + this.props.pageSize;

    const searcher = this.props.searcher || createDefaultSearcher({
      contentType: this.props.contentType,
      params: this.props.searchParams,
      showArchived: this.props.showArchived,
      filterFn: this.props.searchFilterFn
    });

    searcher({
      query: query,
      offset: offset,
      limit: this.props.pageSize
    }).then((result) => {
      this.setState({
        searching: false,
        result: {
          query: query,
          total: result.total,
          offset: result.offset,
          items: previous.concat(result.items)
        }
      });
    });
  }

  componentDidMount() {
    if (this.props.searchOnOpen) {
      this.handleSearch();
    }
  }

  handleQueryChange(e) {
    this.setState({
      query: e.target.value
    });
  }

  handleSearch(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      searching: true
    });

    const query = this.state.query;
    const searcher = this.props.searcher || createDefaultSearcher({
      contentType: this.props.contentType,
      params: this.props.searchParams,
      showArchived: this.props.showArchived,
      filterFn: this.props.searchFilterFn
    });

    searcher({
      query: query,
      limit: this.props.pageSize
    }).then((result) => {
      this.setState({
        searching: false,
        result: {
          limit: this.props.pageSize,
          query: query,
          total: result.total,
          offset: result.offset,
          items: result.items
        }
      });
    });
  }

  render() {
    return (
      <section className="contentful-entity-selector">
        <form onSubmit={this.handleSearch}>
          <div className="form-group has-feedback">
            <input
              type="text"
              placeholder="Søk..."
              className="form-control"
              value={this.state.query}
              onChange={this.handleQueryChange}
              disabled={this.state.searching}
              autoFocus={true}
            />
            <span className="form-control-feedback" aria-hidden="true">
              {this.state.searching &&
                <i className="fa fa-spinner fa-pulse fa-fw"></i>
              }
              {!this.state.searching &&
                <i className="fa fa-search"></i>
              }
            </span>
            {}
            {Boolean(this.state.result) && !this.state.result.items.length &&
              <h2 className="h3">Ingen treff på &laquo;{this.state.result.query}&raquo;</h2>
            }
            {Boolean(this.state.result) && Boolean(this.state.result.items.length) &&
              <h2 className="h3">{this.state.result.total} treff på &laquo;{this.state.result.query}&raquo;</h2>
            }
            <ul className="contentful-entity-list list-unstyled">
              {Boolean(this.state.result) && this.state.result.items.map((entity) => {
                return (
                  <li key={entity.id} className="contentful-entity-list-item">
                    <Entity
                      entity={entity}
                      disabled={this.props.disabled}
                      onSelect={this.props.onSelect}
                      quickAdd={this.props.quickAdd}
                      aspect={1}
                      showIcon={false}
                      allowEdit={false}
                      info={this.props.infoDecorator && this.props.infoDecorator(entity)}
                    />
                  </li>
                );
              })}
            </ul>
            {Boolean(this.state.result) && this.state.result.total > (this.state.result.offset + this.props.pageSize) &&
              <p className="text-center">
                <a
                  className={`${this.state.searching ? 'disabled ' : ''}btn btn-default`}
                  onClick={this.handleLoadMore}
                >
                  {this.state.searching &&
                    <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster...</span>
                  }
                  {!this.state.searching &&
                    <span>Last flere treff <span className="badge">{this.state.result.total - (this.state.result.offset + this.props.pageSize)}</span></span>
                  }
                </a>
              </p>
            }
          </div>
        </form>
      </section>
    );
  }
}

EntitySelector.defaultProps = {
  pageSize: 12,
  searcher: null
};

export default EntitySelector;
